const SITE_URL = 'https://coursepress.lnu.se'
const PATH_PREFIX = '/courses/web-intelligence-ht23'

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null
  },
  header: {
    logoLink: '/',
    title: 'logo-wordmark-en.png',
    courseName: 'Web Intelligence (2DV515)',
    links: [
      { text: 'GitLab', link: 'https://gitlab.lnu.se/2dv515' },
      { text: 'Zoom', link: `${SITE_URL}${PATH_PREFIX}/zoom` },
      { text: 'Moodle', link: 'https://mymoodle.lnu.se/course/view.php?id=61256'},
      { text: 'YouTube', link: 'https://www.youtube.com/cslnu' },
      { text: 'Schedule', link: 'https://cloud.timeedit.net/lnu/web/schema1/ri108719X71Z01Q6Z86g8YY5y7026YX7207gQY6Q5571368879Z2QchmnQ0cZynwcdbQb.html'}
    ]
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true
  },
  siteMetadata: {
    title: 'Linnaeus University',
    language: "en",
    description: 'Documentation built with mdx.',
    ogImage: null
  }
}

module.exports = config
